// extracted by mini-css-extract-plugin
export var actionButton = "_88-1";
export var actionButtons = "_88-2";
export var actions = "_88-0";
export var aiUnread = "_88-10";
export var alignCenter = "_88-h";
export var backWrapper = "_88-3";
export var cellContainer = "_88-4";
export var checkboxContainer = "_88-5";
export var contentContainer = "_88-6";
export var contentHeader = "_88-8";
export var conversationsTableWrapper = "_88-s";
export var draftReplyBadgeContainer = "_88-m";
export var dropdownItem = "_88-b";
export var dropdownItemsContainer = "_88-a";
export var dropdownTitle = "_88-c";
export var errorIcon = "_88-7";
export var filter = "_88-d";
export var gray = "_88-i";
export var headerActionButtons = "_88-e";
export var headerCheckboxContainer = "_88-f";
export var icon = "_88-j";
export var menuContainer = "_88-k";
export var noMoreTicketsIcon = "_88-12";
export var noMoreTicketsSubText = "_88-13";
export var oneLine = "_88-l";
export var optionsButton = "_88-n";
export var plus = "_88-o";
export var portalButtonsWrapper = "_88-g";
export var red = "_88-p";
export var scrolledTop = "_88-9";
export var search = "_88-q";
export var selectedConversationsCount = "_88-r";
export var spinner = "_88-t";
export var strong = "_88-u";
export var summaryCell = "_88-v";
export var tableContainer = "_88-11";
export var tagContainer = "_88-w";
export var threeDots = "_88-x";
export var twoLines = "_88-y";
export var unread = "_88-z";